/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useMemo, useRef, useState} from 'react'
import {useIntl} from 'react-intl'
import clsx from 'clsx'

import {uploadImage} from '@api/requests'

import useOnScreen from '@hooks/useOnScreen'
import useHostBasedUrl from '@app/hooks/useHostBasedUrl'

import {usePhotosStore} from '@store/photos'
import {useCultsStore} from '@pages/CultsPage/store'
import {useTagsStore} from '@pages/TagsPage/store'
import {CatalogCodeName} from '@app/store/useCatalogStore'

import ReactQuillEditor from '@components/molecules/ReactQuillEditor'
import CustomFields from '@components/molecules/CustomFields'
import ThemedSelect from '@components/atoms/ThemedSelect'

import EditSimCatalogParams from '../editsim-drawer/EditSimCatalogParams'

import {AVATAR_IMAGE_TARGET_SIZES} from '@constants/imageUploading'
import {
  DEFAULT_SIM_VALUES,
  SimValuesType,
  TagOptionType,
} from '../editsim-drawer/EditSimDrawerContent'
import {useAddEditCultDrawerStore} from '../addcult-drawer/AddEditCultDrawer'

const AddSimDrawerContent = ({handleValuesChange, setParentAvatar, initialType}) => {
  // console.log('### AddSimDrawerContent.initialType', initialType)
  const intl = useIntl()
  const butOpenEditorRef = useRef<any>()
  const {selectPhoto} = usePhotosStore()
  const {tags: unSortTags, loadTags} = useTagsStore()

  const tags = useMemo(
    () => unSortTags?.map((tag) => ({label: tag.name, value: tag.id})) as TagOptionType[],
    [unSortTags]
  )

  const [values, setValues] = useState<SimValuesType>({...DEFAULT_SIM_VALUES, type: initialType})
  const [customsFields, setCustomFields] = useState<any>([])
  const [catalog, setCatalog] = useState<any>({})

  const [avatar_id, setAvatarId] = useState<number | null>(null)

  const {cults, loadCults} = useCultsStore()
  useEffect(() => {
    loadCults()
  }, [])

  const addSimDrawerRef = useRef(null)
  const visible = useOnScreen(addSimDrawerRef)
  const {open: openAddCultDrawer} = useAddEditCultDrawerStore()

  useEffect(() => {
    if (!visible) {
      setValues({...DEFAULT_SIM_VALUES, type: initialType})
      setCustomFields([])
      setCatalog({})

      setAvatarId(null)
    } else {
      loadTags()
    }
  }, [visible])

  useEffect(() => {
    const {
      avatar,
      first_name,
      species,
      last_name,
      gender,
      selectedTags,
      otherGender,
      is_alive,
      deadReason,
      type,
      city,
      look,
      character_traits,
      life_goals,
      description,
      genderPronoun,
    } = values

    handleValuesChange({
      avatar,
      first_name,
      species,
      last_name,
      avatar_id,
      gender,
      tags: selectedTags.map(({value}) => value),
      other_gender: otherGender,
      is_alive,
      deadReason,
      type,
      city,
      look_id: look,
      character_traits,
      life_goals,
      description,
      // @ts-ignore
      params: {
        fields: customsFields ? customsFields : [],
        genderPronoun,
        catalog,
      },
    })
  }, [values, customsFields, catalog, avatar_id])

  const callBackForCrop = (file) => {
    let reader = new FileReader()
    reader.onload = function (e) {
      if (e?.target?.result) {
        uploadImage(file, 1).then((response) => {
          // console.log('### uploadImage.response', response)
          setAvatarId(response.data.id)
          setValues({...values, avatar: response.data})
          // @ts-ignore
          setParentAvatar(response.data)
        })
      }
      // // @ts-ignore
      // setAvatar(e.target.result)
    }
    reader.readAsDataURL(file)
  }
  function handleFiles(event) {
    let file = event.currentTarget.files[0]
    selectPhoto(file, callBackForCrop, 1, AVATAR_IMAGE_TARGET_SIZES, false, true)

    event.currentTarget.value = ''

    if (butOpenEditorRef?.current)
      //@ts-ignore
      butOpenEditorRef.current.click()
  }

  const avatarUrl = useHostBasedUrl(values.avatar?.url)

  return (
    <div
      className='card-body hover-scroll-overlay-y h-400px pt-5'
      id='kt_help_body'
      ref={addSimDrawerRef}
    >
      {/* @ts-ignore */}
      <button
        ref={butOpenEditorRef}
        style={{pointerEvents: 'none', opacity: 0, position: 'absolute'}}
        data-bs-toggle='modal'
        data-bs-target='#kt_modal_edit_photo'
      />
      <div className='row mb-6'>
        <label className='col-lg-12 col-form-label fw-semibold fs-6'>
          {intl.formatMessage({id: 'TREE.ADD.PHOTO'})}
        </label>
        <div className='col-lg-12'>
          <div className='image-input image-input-outline' data-kt-image-input='true'>
            <div
              style={{
                backgroundImage: avatarUrl
                  ? `url('${avatarUrl}')`
                  : 'url("https://my-engine.ru/modules/users/avatar.png")',
              }}
              className='image-input-wrapper w-125px h-125px'
            />
            <label
              className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
              data-kt-image-input-action='change'
              data-bs-toggle='tooltip'
              title='Change avatar'
            >
              <i className='ki-duotone ki-pencil fs-7'>
                <span className='path1' />
                <span className='path2' />
              </i>
              <input onChange={handleFiles} type='file' name='avatar' accept='.png, .jpg, .jpeg' />
              <input type='hidden' name='avatar_remove' />
            </label>
            <span
              className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
              data-kt-image-input-action='cancel'
              data-bs-toggle='tooltip'
              title='Cancel avatar'
            >
              <i className='ki-duotone ki-cross fs-2'>
                <span className='path1' />
                <span className='path2' />
              </i>
            </span>
          </div>
          <div className='form-text'>{intl.formatMessage({id: 'TREE.ADD.PHOTO.FORMAT'})}</div>
        </div>
      </div>
      <div className='mb-10'>
        <label className='required form-label'>
          {intl.formatMessage({id: 'AUTH.INPUT.FIRST_NAME'})}
        </label>
        <input
          type='text'
          value={values.first_name}
          onChange={(e) => setValues({...values, first_name: e.currentTarget.value})}
          className='form-control'
          placeholder=''
        />
      </div>
      <div className='mb-10'>
        <label className={clsx('form-label', {required: values.type !== 1})}>
          {intl.formatMessage({id: 'AUTH.INPUT.LAST_NAME'})}
        </label>
        <input
          type='text'
          value={values.last_name}
          onChange={(e) => setValues({...values, last_name: e.currentTarget.value})}
          className='form-control'
          placeholder=''
        />
      </div>
      <div className='mb-10'>
        <label className='form-label'>{intl.formatMessage({id: 'SIM.GENDER'})}</label>
        <select
          value={values.gender}
          onChange={(e) => setValues({...values, gender: +e.currentTarget.value})}
          className='form-select'
          aria-label='Select example'
        >
          <option>{intl.formatMessage({id: 'SELECT.GENDER'})}</option>
          <option value={0}>{intl.formatMessage({id: 'SELECT.GENDER.MALE'})}</option>
          <option value={1}>{intl.formatMessage({id: 'SELECT.GENDER.FEMALE'})}</option>
          <option value={2}>{intl.formatMessage({id: 'SELECT.GENDER.OTHER'})}</option>
        </select>
      </div>
      {values.gender === 2 ? (
        <>
          <div className='mb-10'>
            <input
              type='text'
              value={values.otherGender}
              className='form-control'
              placeholder={intl.formatMessage({id: 'SIM.GENDER.ENTER'})}
              onChange={(e) => setValues({...values, otherGender: e.currentTarget.value})}
            />
          </div>
          <div className='mb-10'>
            <label className=' form-label'>
              {intl.formatMessage({id: 'SELECT.GENDER.PRONOUNS'})}
            </label>
            <input
              type='text'
              value={values.genderPronoun}
              className='form-control'
              placeholder=''
              onChange={(e) => setValues({...values, genderPronoun: e.currentTarget.value})}
            />
          </div>
        </>
      ) : null}

      {/* Поле "Город" */}
      <EditSimCatalogParams
        allSimValues={values}
        values={catalog}
        visibleCodeNames={[CatalogCodeName.location]}
        onChange={setCatalog}
        onAllValuesChange={(updatedValues) => {
          // console.log('### onAllValuesChange', updatedValues)
          setValues(updatedValues)
        }}
      />

      <div className='mb-10'>
        <label className=' form-label'>{intl.formatMessage({id: 'SIM.CONDITION'})}</label>
        <select
          value={values.is_alive}
          className='form-select'
          aria-label='Select example'
          onChange={(e) => setValues({...values, is_alive: +e.currentTarget.value})}
        >
          <option>{intl.formatMessage({id: 'SIM.CONDITION.SELECT'})}</option>
          <option value={1}>{intl.formatMessage({id: 'SIM.CONDITION.ALIVE'})}</option>
          <option value={0}>{intl.formatMessage({id: 'SIM.CONDITION.DEAD'})}</option>
        </select>
      </div>

      <EditSimCatalogParams
        allSimValues={values}
        values={catalog}
        visibleCodeNames={[CatalogCodeName.causes_of_death]}
        onChange={setCatalog}
        onAllValuesChange={(updatedValues) => {
          // console.log('### onAllValuesChange', updatedValues)
          setValues(updatedValues)
        }}
      />

      <div className='mb-10'>
        <label className=' form-label'>{intl.formatMessage({id: 'SIM.TYPE'})}</label>
        <select
          value={values.type}
          className='form-select'
          aria-label='Select example'
          onChange={(e) => setValues({...values, type: +e.currentTarget.value})}
        >
          <option>{intl.formatMessage({id: 'SIM.TYPE.SELECT'})}</option>
          <option value={0}>{intl.formatMessage({id: 'SIM.TYPE.PERSON'})}</option>
          <option value={1}>{intl.formatMessage({id: 'SIM.TYPE.PET'})}</option>
        </select>
      </div>
      <div className='mb-10'>
        <label className=' form-label'>{intl.formatMessage({id: 'SIDEBAR.MENU.TAGS'})}</label>
        <ThemedSelect
          value={values.selectedTags}
          placeholder={intl.formatMessage({id: 'SIM.TAG.SELECT'})}
          className='react-select-styled'
          classNamePrefix='react-select'
          isMulti
          options={tags}
          onChange={(selectedTag) =>
            setValues({...values, selectedTags: selectedTag as TagOptionType[]})
          }
        />
      </div>
      <div className='mb-10'>
        <label className='form-label'>{intl.formatMessage({id: 'SIDEBAR.MENU.CULT'})}</label>
        <select
          value={values.look || ''}
          className='form-control'
          onChange={(e) => {
            if (e.target.value === 'ADD_NEW') {
              openAddCultDrawer()
              e.target.value = ''
            } else {
              setValues({...values, look: +e.target.value})
            }
          }}
        >
          <option>{intl.formatMessage({id: 'SIM.CULT.SELECT'})}</option>
          <option
            value='ADD_NEW'
            style={{
              color: 'var(--bs-primary)',
              textAlign: 'left',
            }}
            className='text-start'
          >
            + {intl.formatMessage({id: 'ADD.OCCULT'})}
          </option>
          {cults?.map(({id, name, file}) => (
            <option key={id} value={id}>
              {name}
            </option>
          ))}
        </select>
      </div>

      <EditSimCatalogParams
        allSimValues={values}
        values={catalog}
        hiddenCodeNames={[CatalogCodeName.causes_of_death, CatalogCodeName.location]}
        onChange={setCatalog}
        onAllValuesChange={(updatedValues) => {
          // console.log('### onAllValuesChange', updatedValues)
          setValues(updatedValues)
        }}
      />

      <CustomFields allowCopy values={customsFields} onChange={setCustomFields} />

      <div className='mb-10'>
        <label className=' form-label'>{intl.formatMessage({id: 'TREE.ADD.DESCRIPTION'})}</label>
        <ReactQuillEditor
          initValue={values.description}
          setValue={(value) => setValues({...values, description: value})}
        />
      </div>
      {/* end::Content */}
    </div>
  )
}

export {AddSimDrawerContent}
